// ----------------------------------------------------------------------------------------------------------------------------------------------

export function arrLen(arr) {

  let arrLen = null;
  if (Array.isArray(arr)) {
    arrLen = arr.length;
  }

  return arrLen;
}
